import styled, { css } from 'styled-components';
import { palette, theme } from 'styled-tools';
import TextArea from 'react-textarea-autosize';
import { Card } from '../../components';

const S = {};

export const IdeaContainer = styled.div`
  width: 100%;
  margin: 0 auto;
`;

const section = css`
  display: flex;
  margin: ${theme('spacing.xl')} 0 ${theme('spacing.xxxl')};
`;

S.Container = styled.div`
  width: 80%;
  margin: 10px 10%;
  position: relative;
`;

S.SectionSummary = styled.section`
  ${section};
  justify-content: space-between;
`;

S.CardSummary = styled(Card)`
  flex: 1;
  background-color: ${palette('shareable')};
  color: ${palette('light')};
  flex-direction: column;
  text-align: center;
  margin-right: 5%;
  padding: ${theme('spacing.lg')};
  &:last-child {
    margin-right: 0;
  }
  ${theme('components.CardSummary.container')}
`;

S.TextField = styled(TextArea)`
  resize: none;
  margin-bottom: 20px;
  display: block;
  width: 100%;
  min-height: 100px;
  height: 100%;
  background-color: ${palette('bgInput')};
  color: ${palette('colorInput')};
  border: 1px solid ${palette('borderInput')};
  border-radius: ${theme('borderRadius.sm')};
  font-size: ${theme('fontSize.sm')};
  padding: 8px 8px;
  outline: none;

  &:focus {
    box-shadow: 0 0 0 1px ${palette('primary')};
    border-color: ${palette('borderInputFocus')};
  }

  ${theme('components.TextField')}
  ::placeholder {
    text-align: initial;
  }
`;

S.Notes = styled.p`
  width: 100%;
  padding: 10px;
  white-space: pre-wrap;
  background-color: ${palette('bgInput')};
  color: ${palette('colorInput')};
  border: 1px solid ${palette('borderInput')};
  border-radius: ${theme('borderRadius.sm')};
  font-size: ${theme('fontSize.sm')};
`;

S.ContainerTextField = styled.div`
  ${section};
  padding: 10px;
  margin: 20px 0;
  margin-bottom: 30px;
`;

S.SummaryNumber = styled.div`
  font-size: 70px;
  ${theme('components.CardSummary.number')}
`;

S.SummaryLabel = styled.div`
  font-size: ${theme('fontSize.xs')};
  color: ${palette('light')};
  opacity: 0.7;
`;

S.SectionMembers = styled.div`
  ${section};
  justify-content: center;
`;

S.TeamMood = styled.div`
  ${section};
  display: flex;
  gap: 30px;
  flex-direction: column;
  justify-content: center;
`;

S.PhotoMember = styled.img`
  width: 50px;
  height: 50px;
  margin: ${theme('spacing.xs')};
  border-radius: 50%;
`;

S.CardActionItems = styled(Card)`
  ${section};
  flex-direction: column;
`;

export default S;
